import {CLEAR_STATES,RESOLVE_SHORTLINK_INFO,REDIRECT_TO_LAB_WEBSITE} from './action';

const initialstate = {
    Mylink:null,
    UserAuthPass:false
};


const reducer = (state = initialstate, action) => {

    switch (action.type) {
        case CLEAR_STATES:
            return {
                ...state,
                Mylink:null,
                UserAuthPass:false
            };
        case RESOLVE_SHORTLINK_INFO:
            return {
                ...state,
                Mylink:action.payload,
                UserAuthPass:false
            };
        case REDIRECT_TO_LAB_WEBSITE:
            return {
                ...state,
                UserAuthPass:true
            };
        default:
            return state
    }
}

export default reducer